import {
  LoadingDotsContainer,
  Dot,
} from '@/shared/components/ui/loading-dots/loading-dots.styled';

export const LoadingDots = () => (
  <LoadingDotsContainer>
    <Dot />
    <Dot $delayInSeconds={0.2} />
    <Dot $delayInSeconds={0.4} />
  </LoadingDotsContainer>
);
